import Marquee from "react-fast-marquee";

const ITEMS = ["Built on Quality", "Protecting What Matters", "Premium Materials", "10 Year Guarantee", "Family Run", "Fully Insured"];

export default function ManifestoMarquee() {
  return (
    <div className="py-8 bg-[#1B1B1B] border-y border-white/5 overflow-hidden" data-testid="marquee">
      <Marquee speed={45} gradient={false} autoFill>
        {ITEMS.map((t, i) => (
          <span key={i} className="mx-8 font-head uppercase tracking-tight text-3xl sm:text-5xl text-[#F8F8F8]/90 flex items-center">
            {t}
            <span className="ml-16 w-2 h-2 rounded-full bg-[#D4AF37]" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
